import { SCROLL_DIRECTION } from 'constant';

export const scrollEle = (ele, timeout, direction) => {
    if (direction === SCROLL_DIRECTION.TO_BOTTOM) setTimeout(() => ele.scrollBy({ behavior: 'smooth', top: ele.scrollHeight }), timeout);
    else if (direction === SCROLL_DIRECTION.TO_TOP) {
        setTimeout(() => ele.scrollBy({ behavior: 'smooth', top: -ele.scrollHeight }), timeout);
    }
};
